import React from "react";
export default function SVGList() {
  return (
    <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512">
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M251.328,196.704c-6.24-6.24-16.384-6.272-22.656-0.032L176,249.376l-20.672-20.704c-6.24-6.24-16.384-6.24-22.624,0
			s-6.24,16.384,0,22.624l32,32c3.104,3.136,7.2,4.704,11.296,4.704s8.192-1.568,11.328-4.672l64-64
			C257.568,213.088,257.568,202.944,251.328,196.704z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M251.328,324.704c-6.24-6.24-16.384-6.272-22.656-0.032L176,377.376l-20.672-20.672c-6.24-6.24-16.384-6.24-22.624,0
			s-6.24,16.384,0,22.624l32,32c3.104,3.104,7.2,4.672,11.296,4.672s8.192-1.568,11.328-4.672l64-64
			C257.568,341.088,257.568,330.944,251.328,324.704z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M368,224h-64c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16C384,231.168,376.832,224,368,224
			z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M368,352h-64c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16C384,359.168,376.832,352,368,352
			z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            fill="#000000"
            d="M416,64h-64V48c0-8.832-7.168-16-16-16h-34.72C294.656,13.376,276.864,0,256,0s-38.656,13.376-45.28,32H176
			c-8.832,0-16,7.168-16,16v16H96c-17.632,0-32,14.368-32,32v384c0,17.632,14.368,32,32,32h320c17.632,0,32-14.368,32-32V96
			C448,78.368,433.632,64,416,64z M192,64h32c8.832,0,16-7.168,16-16c0-8.832,7.168-16,16-16c8.832,0,16,7.168,16,16
			c0,8.832,7.168,16,16,16h32v32H192V64z M416,480H96V96h64v16c0,8.832,7.168,16,16,16h160c8.832,0,16-7.168,16-16V96h64V480z"
          />
        </g>
      </g>
    </svg>
  );
}
